import { h } from 'preact';

import NipponTA from '@travel/icons/ui/NipponTA';
import { Translate } from '@travel/translation';

import HotelsLoading from 'components/HotelsLoading';

import styles from './loading.module.scss';

function Loading() {
  return (
    <div className={styles.wrapperLoading} data-testid="loading-shinkansen-container">
      <NipponTA className={styles.nipponTA} />
      <Translate id="Hotel_List.Loading.NTA.Message" className={styles.ntaMessage} />
      <Translate id="Hotel_List.Loading.Waiting.Message_Big" className={styles.messageBig} />
      <Translate id="Hotel_List.Loading.Waiting.Message_Small" className={styles.messageSmall} />
      <div className={styles.loadingAnimation}>
        <HotelsLoading />
      </div>
    </div>
  );
}

export default Loading;
